module.exports = __webpack_public_path__ + "static/img/IMG_20160308_125949.0ab69d3d.jpg";